import {ListViewSectionFilterLink} from '@github-ui/list-view/ListViewSectionFilterLink'
import {ssrSafeWindow} from '@github-ui/ssr-utils'
import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {useIsPlatform} from '@github-ui/use-is-platform'
import {useNavigate, useSearchParams} from '@github-ui/use-navigate'
import {clsx} from 'clsx'
import {useCallback} from 'react'

import styles from './RepositoryProjects.module.css'

interface OpenClosedProjectsProps {
  openCount: number
  closedCount: number
}

export function OpenClosedProjects({openCount, closedCount}: OpenClosedProjectsProps) {
  const [searchParams] = useSearchParams()
  const stateParam = searchParams.get('state')
  const isMac = useIsPlatform(['mac'])
  const navigate = useNavigate()

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>, isOpen: boolean) => {
      // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
      const isMetaKey = isMac ? event.metaKey : event.ctrlKey
      if (isMetaKey || !ssrSafeWindow) {
        return
      }

      event.preventDefault()
      const params = new URLSearchParams(searchParams)
      if (isOpen) {
        params.delete('state')
      } else {
        params.set('state', 'closed')
      }
      const paramString = params.toString()
      const href = paramString ? `${ssrSafeWindow.location.pathname}?${paramString}` : ssrSafeWindow.location.pathname
      navigate(href)
    },
    [isMac, navigate, searchParams],
  )

  let openHrefUrl = ''
  if (ssrSafeWindow) {
    openHrefUrl = ssrSafeWindow.location.pathname
  }
  const closedHrefUrl = `${openHrefUrl}?state=closed`

  const {isBrowser} = useRuntimeEnvironment()

  return (
    <div>
      <ul className={`list-style-none ${clsx(styles.tabsContainer)}`}>
        <li key="section-filter-0">
          <ListViewSectionFilterLink
            key="open"
            title="Open"
            isSelected={isBrowser && stateParam !== 'closed'}
            count={openCount.toLocaleString()}
            href={openHrefUrl}
            onClick={e => onClick(e, true)}
            data-testid="open-projects-tab"
          />
        </li>
        <li key="section-filter-1">
          <ListViewSectionFilterLink
            key="closed"
            title="Closed"
            isSelected={isBrowser && stateParam === 'closed'}
            count={closedCount.toLocaleString()}
            href={closedHrefUrl}
            onClick={e => onClick(e, false)}
            data-testid="closed-projects-tab"
          />
        </li>
      </ul>
    </div>
  )
}
